<template>
  <div class="row">
    <nav
      v-if="menuItems"
      aria-label="länkstig"
      class="col footer-breadcrumbs border-line-down adjust-padding-bottom adjust-padding-top"
    >
      <template v-for="(link, index) in menuItems">
        <a
          v-if="index === 0"
          :key="link + index"
          aria-label="Start"
          :href="link.url"
          class="footer-breadcrumbs__start"
        >
          <no-ssr>
            <svgicon
              name="Logos/ICA"
              class="footer-breadcrumbs__logo"
              role="presentation"
            />
          </no-ssr>
        </a>
        <template
          v-else
          class="footer-breadcrumbs__link"
        >
          <a
            :key="link + index"
            :href="link.url"
            class="footer-breadcrumbs__link__text"
            v-text="link.label"
          />
        </template>
      </template>
    </nav>
    <div v-else>
      No breadcrumb list data
    </div>
  </div>
</template>

<script>
import baseComponentSettings from "@/vue/components/baseComponentSettings"

export default {
  mixins: [baseComponentSettings],
  data () {
    return {
      menuItems: []
    }
  },
  created () {
    this.menuItems = this.data
  },
  mounted () {
    if (this.menuItems.length === 0) {
      if (window && window._vueContext && window._vueContext.breadcrumbs) {
        this.menuItems = window._vueContext.breadcrumbs
      }
    }
  }
}
</script>

<style lang="scss">
.footer-breadcrumbs {
  margin-bottom: 1.75rem;
  padding-bottom: 0.625rem;
  position: relative;

  &__logo.svg-icon {
    fill: $color-red;
    height: 1rem;
    width: 1.6875rem;
    vertical-align: -0.125rem;
  }

  a {
    @include font(text,2, normal);

    color: $color-secondary-text;
    display: inline-block;
    padding-right: 2.5rem;
    position: relative;
    text-decoration: none;

    &::after {
      border-right: 0.0625rem solid $color-grey-dark;
      border-top: 0.0625rem solid $color-grey-dark;
      content: "";
      display: inline-block;
      height: 0.375rem;
      margin: 0 1rem;
      position: absolute;
      right: -0.3125rem;
      top: 0.3125rem;
      transform: translate(-0.3125rem, 0) rotate(45deg);
      width: 0.375rem;
    }

    &:last-of-type {
      &::after {
        content: none;
      }
    }
  }

  &.adjust-padding-bottom {
    padding-bottom: 0.96875rem;
  }

  &.adjust-padding-top {
    padding-top: 0.96875rem;
  }
}
</style>
